import clsx from 'clsx';
import { useContext, useMemo } from 'react';
import { type DayOfWeek } from 'weekstart';

import { Day } from './Day.js';
import * as styles from '../Calendar.sty.js';
import { DayViewContext } from '../contexts/DayViewContext.js';
import { useCalendarContext } from '../hooks/useCalendarContext.js';
import {
  NUMBER_OF_WEEK_ROWS,
  NUMBER_OF_WEEKDAYS,
} from '../types/calendarConfiguration.js';
import { getDays } from '../utils/helpers.js';

/** @internal */
export function Days({ weekStartsOn }: Readonly<{ weekStartsOn: DayOfWeek }>) {
  const { state } = useCalendarContext();
  const { setHoveredDate } = useContext(DayViewContext);

  const days = useMemo(
    () => getDays(state.activeDate, weekStartsOn),
    [state.activeDate, weekStartsOn],
  );

  return (
    <tbody
      onMouseLeave={() => {
        setHoveredDate?.(null);
      }}
    >
      {new Array(NUMBER_OF_WEEK_ROWS).fill(0).map((_, index) => (
        <tr
          key={`${days[index].date}-row-${index}`}
          className={clsx([styles.row, styles.dayRow])}
        >
          {days
            .slice(
              index * NUMBER_OF_WEEKDAYS,
              index * NUMBER_OF_WEEKDAYS + NUMBER_OF_WEEKDAYS,
            )
            .map((day, index) => (
              <Day
                date={day.date}
                position={index + 1}
                isCurrentMonthDay={day.isCurrentMonthDay}
                key={day.date.toISOString()}
              />
            ))}
        </tr>
      ))}
    </tbody>
  );
}
